import { ISchedule } from 'legacy/lut/classes/models/partner360/ELT/IELTFormData'
import { getTimeFromDate } from 'legacy/lut/components/widgets/public/partner360/ELT/ui/meetingLogistics/meetingAgenda/helpers/getTimeFromDate'

export const getSchedule = (schedule: ISchedule) => {
  if (!schedule?.Start || !schedule?.End) {
    return ''
  }
  return `${getTimeFromDate(schedule.Start)} - ${getTimeFromDate(schedule.End)}`
}
